

export const personaloities = [
    {
        label: 'Pioneer',
        key: 'pioneer'
    },
    {
        label: 'Influencer',
        key: 'influencer'
    },
    {
        label: 'Team Player',
        key: 'teamPlayer'
    },
    {
        label: 'Logical Thinker',
        key: 'logicalThinker'
    },
    {
        label: 'Persuader',
        key: 'persuader'
    },
    {
        label: 'Achiever',
        key: 'achiever'
    },
    {
        label: 'Perfectionist',
        key: 'perfectionist'
    },
    {
        label: 'Collaborator',
        key: 'collaborator'
    },
    {
        label: 'Accessor',
        key: 'assessor'
    },
    {
        label: 'Implementor',
        key: 'implementor'
    },
    {
        label: 'Motivator',
        key: 'motivator'
    },
    {
        label: 'Leader',
        key: 'leader'
    },
    {
        label: 'Administrator',
        key: 'administrator'
    },
    {
        label: 'Mediator',
        key: 'mediator'
    }, {
        label: 'All Rounder',
        key: 'allRounder'
    }
]